<template>
  <div class="container-fluid">
    <div>
      <div class="card">
        <div class="card-header">
          <div class="row">
            <div class="col col-xs-2">
              <h4 class="panel-title">
                <span class="title">Gerenciamento de AIDF.</span>
                <br/>
                <span class="navigation">Solicitações > AIDF</span>
              </h4>
            </div>
          </div>
        </div>
        <div class="card-body">
          <form name="form" @submit.prevent="onSubmit">
            <div class="row">
              <div class="col-md-2 mb-2">
                <label for="nome">Número AIDF: *</label>
                <span class="p-fluid">
                  <InputText
                    type="number"
                    id="nome"
                    v-model="aidf.numeroAidf"
                  />
                </span>
              </div>
            </div>
            <div class="row">
              <div class="col-md-3 mb-2">
                <label for="desc">Gráfica Responsável: *</label>
                <span class="p-fluid">
                  <InputText
                    type="text"
                    id="desc"
                    v-model="aidf.graficaResponsavel" 
                  />
                </span>
              </div>
            </div>
            <div class="row">
              <div class="col-md-2 mb-2">
                <label for="desc">Tipo de Documento: *</label>
                <span class="p-fluid">
                  <InputText
                  type="text"
                  id="desc"
                  v-model="aidf.tipoDocumento" maxlength="10"/>
                </span>
              </div>
            </div>
            <div class="row">
              <div class="col-md-2 mb-2">
                <label for="nome">Numeração Inicial: *</label>
                <span class="p-fluid">
                  <InputText
                    type="number"
                    id="nome"
                    v-model="aidf.numeracaoIni"
                  />
                </span>
              </div>
              <div class="col-md-2 mb-2">
                <label for="nome">Numeração Final: *</label>
                <span class="p-fluid">
                  <InputText
                    type="number"
                    id="nome"
                    v-model="aidf.numeracaoFin"
                  />
                </span>
              </div>
            </div>
            <div class="row">
              <div class="col-md-2 mb-2">
                <label for="desc">Série: *</label>
                <span class="p-fluid">
                  <InputText
                    type="text"
                    id="desc"
                    v-model="aidf.serie" maxlength="5"
                  />
                </span>
              </div>
            </div>
            <div class="row">
              <div class="col-md-2 mb-2">
                <label for="desc">Quantidade: *</label>
                <span class="p-fluid">
                  <InputText
                    type="number"
                    id="desc"
                    v-model="aidf.quantidade"
                  />
                </span>
              </div>
            </div>
            <hr />
            <template>
              <Button
                label="Gravar"
                title="Gravar"
                type="submit"
                class="p-button-primary mr-2 p-button-success"
                icon="pi pi-check"
                :disabled="loading"
              >
              </Button>
              <router-link to="/aidfConsulta">
                <Button
                  label="Voltar"
                  title="Voltar"
                  type="button"
                  class="p-button-primary mr-2"
                  icon="pi pi-arrow-left"
                  :disabled="loading"
                ></Button>
              </router-link>
            </template>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import LoginService from "../services/acesso/login.service";
import AidfService from "../services/nfse/aidf.service";
import Aidf from "../models/nfse/Aidf";

export default {
  name: "aidfCadastro",
  data() {
    return {
      currentUser: null,
      loading: false,
      tiposDocumento: [
        { name: "CPF", key: "CPF" },
        { name: "CNPJ", key: "CNPJ" },
      ],
      dataEmissao: new Date(),
      aidf: new Aidf()
    };
  },
  created() {
    this.currentUser = LoginService.currentUserValue;
    this.aidfId = this.$route.params.id;

    if (this.aidfId != null) {
      setTimeout(async () => {
        await AidfService.get(this.aidfId).then(
        response =>{
          this.aidf = response.data;
        },
        error => {
          let errorMessage = "Houve um problema ao buscar a Solicitação AIDF!";
          if (error.response) {
            errorMessage = error.response.data;
          }
          this.$toast.add({
            severity: "error",
            summary: errorMessage
          });
        });
      }, 250);
    }
  },
  methods: {
    onSubmit() {
      this.loading = true;
      this.$validate().then(success => {
        if (success) {
          this.salvar();
        }
      });
      this.loading = false;
    },
    salvar() {
      var msg = null;
      if(!this.aidf.numeroAidf){
        msg = "O Preenchimento do Campo Número AIDF é Obrigatório";
      }else if(!this.aidf.graficaResponsavel){
        msg = "O Preenchimento do Campo Gráfica Responsável é Obrigatório";
      }else if(!this.aidf.tipoDocumento){
        msg = "O Preenchimento do Campo Tipo Documento é Obrigatório";
      }else if(!this.aidf.numeracaoIni){
        msg = "O Preenchimento do Campo Número Inicial é Obrigatório";
      }else if(!this.aidf.numeracaoFin){
        msg = "Preenchimento do Campo Número Final é Obrigatório";
      }else if(!this.aidf.serie){
        msg = "O Preenchimento do Campo Série é Obrigatório";
      }else if(!this.aidf.quantidade){
        msg = "O Preenchimento do Campo Quantidade é Obrigatório";
      }else if(this.aidf.serie.length > 5){
        msg = "O valor do Campo Série não pode ser maior que 5 Caracteres.";
      }
      if(!msg){
        this.aidf.idCliente = this.currentUser.usuario.idCliente;
        this.aidf.idContribuinte = this.currentUser.contribuinte.idContribuinte;
        AidfService.saveAidf(this.currentUser.contribuinte.documento, this.currentUser.contribuinte.nome, this.aidf).then(
          data => {
            console.log(data);
            this.$toast.add({
              severity: "success",
              summary: "Solicitação AIDF salva com sucesso"
            });
            this.$router.push("/aidfConsulta");
          },
          error => {
            let errorMessage = "Houve um problema ao salvar a Solicitação AIDF!";
            if (error.response) {
              errorMessage = error.response.data;
            }
            this.$toast.add({
              severity: "error",
              summary: errorMessage
            });
          }
        );
      }else{
        this.$toast.add({
          severity: "error",
          summary: msg,
          life:4000
        });
        return;
      }
    }
  },
  validators: {

  }
};
</script>

<style scoped>
</style>